import { render, staticRenderFns } from "./PersonGeneralInformationGlobal.vue?vue&type=template&id=ebba03e8&scoped=true&"
import script from "./PersonGeneralInformationGlobal.vue?vue&type=script&lang=js&"
export * from "./PersonGeneralInformationGlobal.vue?vue&type=script&lang=js&"
import style0 from "./PersonGeneralInformationGlobal.vue?vue&type=style&index=0&id=ebba03e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebba03e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VRow,VSelect,VSpacer,VTextField})
